import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import { reduxForm } from 'redux-form/immutable';
import { Form } from 'formik';
import { each, isArray, isFunction, slice } from 'lodash-es';
import LoadingScreen from '../LoadingIndicator';

class FormBox extends Component {
  renderSubComponents = () => {
    const subComponentMapping = {
      children: this.renderChildren,
      loader: this.renderLoader,
      submitButton: this.renderSubmitButton,
      error: this.renderErrors,
      success: this.renderSuccess,
    };

    const { subComponentOrder, componentClasses } = this.props;
    const componentOrder = subComponentOrder || [];

    const subComponents = componentOrder.map(subComponentConfig =>
      subComponentMapping[subComponentConfig.name](subComponentConfig),
    );
    return (
      <div
        className={
          componentClasses && componentClasses.subComponentsContainerClass
        }
      >
        {subComponents}
      </div>
    );
  };

  renderChildren = () => {
    const { children, componentClasses } = this.props;

    return (
      <div
        key="form-children"
        className={componentClasses && componentClasses.childrenContainerClass}
      >
        {children}
      </div>
    );
  };

  renderLoader = () => {
    const { isSubmitting } = this.props;
    if (isSubmitting) {
      return <LoadingScreen hangTight="true" />;
    }
    return null;
  };

  renderSubmitButton = submitButtonConfig => {
    const {
      showButtonOnlyOnDirty,
      text,
      component,
      isAbsent,
      showLoader,
      disabled,
    } = submitButtonConfig;
    const {
      dirty,
      isSubmitting,
      componentClasses,
      isValid,
      submitForm,
    } = this.props;

    const buttonDisabled = disabled || isSubmitting || !isValid;

    if ((showButtonOnlyOnDirty && !dirty) || isAbsent) {
      return null;
    }

    if (component) {
      return component({
        key: 'form-submit-button',
        onClick: this.onSubmitClick,
        isSubmitting,
      });
    }
    let loadingClassName = '';
    if (showLoader && isSubmitting) {
      loadingClassName = 'is-loading';
    }

    return (
      <div
        className={componentClasses && componentClasses.buttonContainerClass}
      >
        <button
          key="form-submit-button"
          disabled={buttonDisabled}
          className={
            (componentClasses && componentClasses.buttonClass
              ? `${componentClasses.buttonClass} ${loadingClassName}`
              : false) || `btn ${loadingClassName}`
          }
          type="submit"
          onClick={submitForm}
        >
          {text} <i className="icon icon-form-btn-right" />
        </button>
      </div>
    );
  };

  renderErrors = () => {
    const {
      errors: { submissionError },
      componentClasses,
    } = this.props;
    if (submissionError) {
      const formErrors = [];
      {
        isArray(submissionError)
          ? each(slice(submissionError, 0, 4), e =>
              formErrors.push(
                <div
                  className={componentClasses && componentClasses.errorClass}
                  key="_error"
                >
                  {e}
                </div>,
              ),
            )
          : formErrors.push(
              <div
                className={componentClasses && componentClasses.errorClass}
                key="_error"
              >
                {submissionError}
              </div>,
            );
      }

      return <div key="form-error">{formErrors}</div>;
    }

    return null;
  };

  renderSuccess = () => {
    const { submitSucceeded, successMsg, componentClasses } = this.props;

    if (submitSucceeded && successMsg) {
      return (
        <div
          key="form-success"
          className={
            (componentClasses && componentClasses.successClass) ||
            'form-success'
          }
        >
          {successMsg}
        </div>
      );
    }
    return null;
  };

  render() {
    const { onSubmit, componentClasses, action } = this.props;

    return (
      <React.Fragment>
        <div
          className={componentClasses && componentClasses.formContainerClass}
        >
          {action && (
            <form
              className={componentClasses && componentClasses.formClass}
              onSubmit={onSubmit}
              onChange={this.onFormChange}
              action={action}
              method="post"
            >
              {isFunction(this.props.children) &&
                this.props.children({ ...this.props })}

              {this.renderSubComponents()}
            </form>
          )}
          {!action && (
            <Form className={componentClasses && componentClasses.formClass}>
              {isFunction(this.props.children) &&
                this.props.children({ ...this.props })}

              {this.renderSubComponents()}
            </Form>
          )}
        </div>
      </React.Fragment>
    );
  }
}

FormBox.propTypes = {
  submitFailed: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  dirty: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  componentClasses: PropTypes.object,
  subComponentOrder: PropTypes.arrayOf(PropTypes.object),
  successMsg: PropTypes.string,
  onSubmit: PropTypes.func,
  action: PropTypes.string,
};

export default FormBox;
